<template>
    <div class="stamp-shop">
        <!-- 顶部印花信息 -->
        <div class="header">
            <div class="header-bg-pattern"></div>
            <div class="header-content">
                <div class="header-left">
                    <div class="stamp-icon-wrapper">
<!--                        <span class="stamp-icon">🌸</span>-->
                        <img style="width: 22px; height: 33px;" src="../../assets/yakult-stamp.png"/>
                    </div>
                    <div class="stamp-info">
                        <span class="header-label">我的印花</span>
                        <span class="header-stamp">{{ userStamps }}</span>
                    </div>
                </div>
                <div class="divider"></div>
                <div class="header-right">
                    <div class="exchange-info">
                        <span class="header-label">可兑换商品数</span>
                        <div class="exchange-count-wrapper">
                            <span class="exchange-count">{{ availableCount }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 功能按钮区 -->
        <div class="function-bar">
            <div class="function-item" @click="onStampExchange">
                <div class="function-icon exchange-icon"></div>
                <span class="function-text">印花兑换</span>
            </div>
            <div class="function-item" @click="onStampLottery">
                <div class="function-icon lottery-icon"></div>
                <span class="function-text">抽奖活动</span>
            </div>
            <div class="function-item" @click="onExchangeRecord">
                <div class="function-icon record-icon"></div>
                <span class="function-text">中奖/兑换券</span>
            </div>
            <div class="function-item" @click="onHelpCenter">
                <div class="function-icon help-icon"></div>
                <span class="function-text">印花记录</span>
            </div>
        </div>

        <!-- 热门兑换区 -->
        <div class="hot-section">
            <div class="section-header">
                <span class="section-title">热门兑换</span>
                <span class="section-more" @click="onStampExchange">更多 ›</span>
            </div>

            <div class="goods-grid">
                <div
                    v-for="item in hotGoods"
                    :key="item.id"
                    class="goods-item"
                    @click="onExchangeTap(item.id)"
                >
                    <div class="goods-image-wrapper">
                        <img class="goods-image" :src="item.image" :alt="item.name" />
                        <div v-if="item.tag" :class="['goods-tag', item.tagClass]">{{ item.tag }}</div>
                    </div>
                    <div class="goods-info">
                        <span class="goods-name">{{ item.name }}</span>
                        <div class="goods-bottom">
                            <div class="stamp-price" v-if="item.isFirstExchange">
<!--                                <span class="original-stamp">{{item.originalStamps}}印花</span>-->
                                <span class="discount-stamp">{{item.stamps}}印花</span>
                            </div>
                            <div class="goods-stamp" v-else>{{item.stamps}}印花</div>
                            <div class="exchange-btn">立即兑换</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { GetExchangeGoodsList, ExchangeSearch } from '../../api/StampShop'
import axios from '../../utils/axios'
import {BASE_URL} from "@/config/app";

export default {
    name: 'StampShop',
    data() {
        return {
            userStamps: 0,
            availableCount: '',
            hotGoods: []
        }
    },
    created() {
        this.loadStampData()
    },
    activated() {
        this.loadStampData()
    },
    methods: {
        loadStampData() {
            this.getExchangeGoodsList()
            this.getExchangeSearch()
            this.getUserStamps()
        },

        // 获取兑换商品列表
        async getExchangeGoodsList() {
            try {
                const res = await GetExchangeGoodsList({ activityId: 1 })

                if (res.code === this.$API_CODE.OK) {
                    const exchangeGoodsList = []
                    res.data.forEach((item) => {
                        exchangeGoodsList.push({
                            id: item.id,
                            name: item.productname,
                            stamps: item.stampQuantity,
                            isFirstExchange: item.isFirstExchange,
                            originalStamps: item.originalStampQuantity,
                            image: BASE_URL + item.imgurl,
                            tag: item.tag === 1 ? '热门' : item.tag === 2 ? '新品' : '',
                            tagClass: item.tag === 1 ? 'hot' : item.tag === 2 ? 'new' : ''
                        })
                    })
                    this.hotGoods = exchangeGoodsList
                }
            } catch (error) {
                console.error('获取兑换商品列表失败:', error)
            }
        },

        // 获取可兑换商品数量
        async getExchangeSearch() {
            try {
                const res = await ExchangeSearch({})

                if (res.code === this.$API_CODE.OK) {
                    this.availableCount = `${res.data.qtyOfUse}/${res.data.qtyOfTotal}次`
                }
            } catch (error) {
                console.error('获取可兑换商品数量失败:', error)
            }
        },

        // 获取用户印花数量
        async getUserStamps() {
            try {
                const res = await axios({
                    url: '/stamp',
                    method: 'get',
                    params: {}
                })

                if (res.code === this.$API_CODE.OK) {
                    this.userStamps = res.data.stampQuantity
                }
            } catch (error) {
                console.error('获取用户印花数量失败:', error)
            }
        },

        // 印花兑换
        onStampExchange() {
            this.$router.push('/stampExchangePage')
        },

        // 印花抽奖
        onStampLottery() {
            this.$router.push('/lottery')
        },

        // 兑换记录
        onExchangeRecord() {
            this.$router.push('/exchangeRecord')
        },

        // 印花记录
        onHelpCenter() {
            this.$router.push('/memberPrintingDetail')
        },

        // 点击兑换商品
        onExchangeTap(id) {
            this.$router.push({
                path: '/stampExchangeDetail',
                query: {
                    id: id,
                    userStamps: this.userStamps
                }
            })
        }
    }
}
</script>

<style scoped lang="scss">
.stamp-shop {
    background-color: #f5f5f5;
    min-height: 100vh;
    padding-bottom: 20px;
}

/* 顶部印花信息 */
.header {
    position: relative;
    background: linear-gradient(135deg, #ff6b6b 0%, #ff4757 50%, #ff3838 100%);
    padding: 25px 15px 20px;
    overflow: hidden;
}

.header-bg-pattern {
    position: absolute;
    top: -25px;
    right: -25px;
    width: 150px;
    height: 150px;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.15) 0%, transparent 70%);
    border-radius: 50%;
}

.header-bg-pattern::before {
    content: '';
    position: absolute;
    bottom: -40px;
    left: -40px;
    width: 100px;
    height: 100px;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, transparent 70%);
    border-radius: 50%;
}

.header-content {
    position: relative;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.header-left {
    display: flex;
    align-items: center;
    flex: 1;
}

.stamp-icon-wrapper {
    width: 44px;
    height: 44px;
    background: rgba(255, 255, 255, 0.25);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 10px;
    backdrop-filter: blur(5px);
    border: 1px solid rgba(255, 255, 255, 0.3);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.stamp-icon {
    font-size: 24px;
    filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1));
}

.stamp-info {
    display: flex;
    flex-direction: column;
}

.header-label {
    color: rgba(255, 255, 255, 0.9);
    font-size: 12px;
    margin-bottom: 4px;
    letter-spacing: 0.5px;
}

.header-stamp {
    color: #fff;
    font-size: 32px;
    font-weight: bold;
    line-height: 1;
    text-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
}

.divider {
    width: 1px;
    height: 40px;
    background: linear-gradient(to bottom, transparent, rgba(255, 255, 255, 0.4), transparent);
    margin: 0 15px;
}

.header-right {
    display: flex;
    align-items: flex-end;
}

.exchange-info {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}

.exchange-count-wrapper {
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(5px);
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 8px;
    padding: 6px 12px;
    margin-top: 4px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.exchange-count {
    color: #fff;
    font-size: 20px;
    font-weight: bold;
    letter-spacing: 1px;
}

/* 功能按钮区 */
.function-bar {
    background: #fff;
    margin: 15px 15px 10px;
    border-radius: 10px;
    padding: 18px 0;
    display: flex;
    justify-content: space-around;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
    position: relative;
    z-index: 2;
}

.function-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    cursor: pointer;

    &:active .function-icon {
        transform: scale(0.95);
    }
}

.function-icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.12);
    transition: all 0.3s;
}

.exchange-icon {
    background: linear-gradient(135deg, #a8e6cf 0%, #7bc8a4 100%);

    &::before {
        content: '🎁';
        font-size: 22px;
    }
}

.lottery-icon {
    background: linear-gradient(135deg, #ffd93d 0%, #ffcc00 100%);

    &::before {
        content: '🎫';
        font-size: 22px;
    }
}

.record-icon {
    background: linear-gradient(135deg, #ff8a8a 0%, #ff6b6b 100%);

    &::before {
        content: '🕐';
        font-size: 22px;
    }
}

.help-icon {
    background: linear-gradient(135deg, #74b9ff 0%, #0984e3 100%);

    &::before {
        content: '📋';
        font-size: 22px;
    }
}

.function-text {
    font-size: 12px;
    color: #666;
    font-weight: 500;
}

/* 热门兑换区 */
.hot-section {
    background: #fff;
    margin: 15px 15px 10px;
    border-radius: 10px;
    padding: 5px;
}

.section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    padding: 0 4px;
}

.section-title {
    font-size: 17px;
    font-weight: bold;
    color: #333;
    position: relative;
    padding-left: 10px;
    letter-spacing: 1px;

    &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 4px;
        height: 16px;
        background: linear-gradient(to bottom, #ff6b6b, #ff4757);
        border-radius: 2px;
    }
}

.section-more {
    font-size: 13px;
    color: #4caf50;
    display: flex;
    align-items: center;
    cursor: pointer;
}

.goods-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
}

.goods-item {
    background: #fff;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.03);
    transition: all 0.3s;
    cursor: pointer;

    &:active {
        transform: scale(0.98);
        box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
    }
}

.goods-image-wrapper {
    position: relative;
    width: 100%;
    height: 165px;
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.goods-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.goods-tag {
    position: absolute;
    top: 8px;
    left: 8px;
    background: linear-gradient(135deg, #ff6b6b, #ff4757);
    color: #fff;
    font-size: 11px;
    padding: 4px 10px;
    border-radius: 10px;
    font-weight: 500;
    box-shadow: 0 2px 6px rgba(255, 71, 87, 0.3);
}

.goods-tag.hot {
    background: linear-gradient(135deg, #ff5722, #ff5722);
}

.goods-tag.new {
    background: linear-gradient(135deg, #ff6b6b, #ff4757);
}

.goods-info {
    padding: 12px;
}

.goods-name {
    text-align: left;
    display: block;
    font-size: 14px;
    color: #333;
    margin-bottom: 10px;
    line-height: 1.5;
    height: 42px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    font-weight: 500;
}

.goods-bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.goods-stamp {
    font-size: 16px;
    color: #ff4757;
    font-weight: bold;
}

.stamp-price {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.original-stamp {
  font-size: 12px;
  color: #999;
  text-decoration: line-through;
}

.discount-stamp {
  font-size: 16px;
  color: #ff4757;
  font-weight: bold;
}

.exchange-btn {
    background: linear-gradient(135deg, #ea2d53, #ea2d53);
    color: #fff;
    font-size: 12px;
    padding: 6px 14px;
    border-radius: 15px;
    font-weight: 500;
    box-shadow: 0 2px 6px rgba(76, 175, 80, 0.3);
}
</style>
